export const GRAPHQL_ENDPOINT =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3001/graphql"
    : "https://leadexpertsny.com/graphql";

export const REST_ENDPOINT =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3001"
    : "https://leadexpertsny.com";
